import BaseCardModifierHandler from './BaseCardModifierHandler';

export default class RopeModifierHandler extends BaseCardModifierHandler {
    public updateVisibility(faceUp: boolean): void {
        this.renderable.visible = true;
    }
}
